import React, { useState } from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18next';
import { Layout, Icon, Anchor } from 'antd';
import PrivateLayoutWrapper from './styles';
import Header from '../../containers/Header';
import SideBar from '../../containers/SideBar';

const { Content, Footer } = Layout;

const mobileTabs = [
  {
    key: 'home',
    text: 'Profile',
    url: '/',
    icon: 'home',
  },
  {
    key: 'user',
    text: 'Profile',
    url: '#',
    icon: 'user',
  },
];

const PrivateLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const toggle = () => {
    setCollapsed(!collapsed);
  };
  // if (!hasPrivateLayoutWrapper) {
  //   return (
  //     <PrivateLayoutWrapper className="mainView mainWithoutSidebar">
  //       <Content className="container">
  //         <div className="content">{children}</div>
  //       </Content>
  //     </PrivateLayoutWrapper>
  //   );
  // }
  return (
    <PrivateLayoutWrapper collapsed={`${collapsed}`}>
      <input
        onChange={() => {}}
        id="collapsedTracker"
        type="checkbox"
        checked={!collapsed}
      />
      <label
        role="presentation"
        htmlFor="collapsedTracker"
        className="overlay"
        onClick={toggle}
      />
      <SideBar toggle={toggle} collapsed={collapsed} />
      <Layout>
        <Anchor>
          <Header onToggle={toggle} collapsed={collapsed} />
        </Anchor>
        <Content>
          <div className="content">{children}</div>
        </Content>
        <Footer
          className="footer"
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <div>{I18n.t('appInfo.name')}</div>
          <div>
            <span>{I18n.t('appInfo.footer')}</span>
            <Icon
              type="heart"
              theme="filled"
              style={{ marginLeft: '5px', color: 'red' }}
            />
          </div>
        </Footer>
        <Footer className="footerMobile">
          {mobileTabs.map((tab) => (
            <a href={tab.url} key={tab.key}>
              <Icon type={tab.icon} className="tabIcon" />
            </a>
          ))}
        </Footer>
      </Layout>
    </PrivateLayoutWrapper>
  );
};

PrivateLayout.propTypes = {
  children: PropTypes.any,
  hasPrivateLayoutWrapper: PropTypes.bool,
  // title: PropTypes.string,
};

export default PrivateLayout;
